import firebase from 'firebase';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { FirebaseConfig } from '../types/types';

const getDownloadUrl = (ref: string) =>
  firebase
    .storage()
    .ref(ref)
    .getDownloadURL()
    .then((url) => url as string);

export const ConfigContext = createContext<FirebaseConfig | null>(null);

export const ConfigProvider: React.FC = ({ children }) => {
  const [data] = useDocumentData<FirebaseConfig>(
    firebase.firestore().collection('config').doc('default')
  );

  const [result, setResult] = useState(data);

  useEffect(() => {
    const fetchData = async () => {
      if (data) {
        try {
          const logoCover = data.logo?.cover
            ? await getDownloadUrl(data.logo.cover)
            : '';
          const heroCover = data.hero?.cover
            ? await getDownloadUrl(data.hero.cover)
            : '';
          const landingHeader = data.landingHeader?.cover
            ? await getDownloadUrl(data.landingHeader.cover)
            : '';
          setResult({
            ...data,
            logo: { ...data.logo, imgUrl: logoCover },
            hero: { ...data.hero, imgUrl: heroCover },
            landingHeader: { ...data.landingHeader, imgUrl: landingHeader },
          });
        } catch (e) {
          console.error(e);
        }
      } else {
        setResult(data);
      }
    };

    fetchData();
  }, [data]);

  return (
    <ConfigContext.Provider value={result || null}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
